<template>
    <div v-if="isLoaded">
        <div class="content-header row">
            <div class="content-header-left col-12 col-md-6 mb-2">
                <h4 class="content-header-title mb-0">{{ breadcrumb.titulo }}</h4>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">{{ breadcrumb.p1 }}
                            </li>
                            <li class="breadcrumb-item" v-if="breadcrumb.p2">{{ breadcrumb.p2 }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-center col-md-6 col-12">
                <div class="media float-right">
                    <div class="media-body">
                        <h5 class="m-0">{{ dateTime }}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    data() {
        return {
            dateTime: moment().format('DD/MM/YYYY HH:mm'),
            welcome: '',
        }
    },
    mounted() {
        this.timer = setInterval(() => {
            this.dateTime = moment().format('DD/MM/YYYY HH:mm');
        }, 1000);
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
    },
    computed: {
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        },
        apiVersion: {
            get() {
                return this.$store.getters.api_version;
            }
        },
       breadcrumb:
       {
           get ()
           {
               return this.$store.getters.breadcrumb;
           }
       },
   }
}
</script>
